import React from 'react';
import { Modal } from 'htlib-copy';

import { func } from 'prop-types';
import customTypes from 'types';
import { makePretty } from 'utils/case';

import './ValidationStatsModal.scss';

export default function ValidationStatsModal({ onClose, stats }) {
  return (
    <Modal onClose={onClose}>
      <div className="ValidationStatsModal">
        <div className="ValidationStatsModal__stats">
          {Object.entries(stats).map(([key, value]) => (
            <p key={key}>
              <span className="field">{makePretty(key)}</span>
              <span className="value">{value}</span>
            </p>
          ))}
        </div>
      </div>
    </Modal>
  );
}

ValidationStatsModal.propTypes = {
  onClose: func.isRequired,
  stats: customTypes.misc.updateStats,
};

ValidationStatsModal.defaultProps = {
  stats: {},
};
